import React from 'react';
import { Navigate } from 'react-router-dom';
import { permissionConfig } from '../helpers/permissionConfig';
import usePermissions from '../hooks/usePermissions';

const ProtectedRoute = ({ children, path }) => {
  
  const { permissions, isLoading } = usePermissions();

  const hasPermission = (module, permissionKey) => {
    return permissions.some(perm => perm[module] === permissionKey);
  };


  const findMenuItemByPath = (menuItems, currentPath) => {
    for (const item of menuItems) {
      if (item.path === currentPath) {
        return item;
      }
      if (item.subMenu && item.subMenu.length > 0) {
        const subItem = item.subMenu.find(sub => sub.path === currentPath);
        if (subItem) {
          return { ...subItem, permission_module: item.permission_module };
        }
      }
    }
    return null;
  };

  // Always allow dashboard and login
  if (path === '/dashboard' || path === '/login' || path === '/') {
    return children;
  }

  // Wait for permissions to load — covers both isLoading AND empty permissions with token
  const hasAuthToken = !!localStorage.getItem('authToken');
  if (isLoading || (hasAuthToken && permissions.length === 0)) {
    return null;
  }

  const menuItem = findMenuItemByPath(permissionConfig, path);

  if (!menuItem) {
    return <Navigate to="/dashboard" replace />;
  }
  
  const hasAccess = hasPermission(menuItem.permission_module, menuItem.permission_key);
  
  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  console.log(`menuItem.permission_module  : ${menuItem.permission_module}  |  menuItem.permission_key : ${menuItem.permission_key} | hasAccess ${hasAccess}`);

  return children;
};

export default ProtectedRoute;
